module.exports = Promise.all([__parcel__import__("i7cc4"), __parcel__import__("b43Ug")]).then(() => parcelRequire('g36Vt'));